import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useContext, useMemo } from 'react';

import { TABLET } from '@app/constants/devicesWidth';
import { useNewUserAccessRights, useWindowSize } from '@app/hooks';
import { HeaderContext } from '@app/providers';

import type { FC } from 'react';

import './ClientFieldsPageHeader.scss';

export const ClientFieldsPageHeader: FC = () => {
  const { header } = useContext(HeaderContext);

  const {
    userAccessRights: { Clients },
  } = useNewUserAccessRights();

  const { innerWidth, isMobile } = useWindowSize();

  const label = useMemo(
    () => (innerWidth <= TABLET ? '' : 'Добавить поле'),
    [innerWidth]
  );

  if (!Clients?.IsEdit) {
    return null;
  }

  const openModal = header.openClientFieldModal;

  return (
    <div className="ClientFieldsPageHeader">
      <Button
        type="primary"
        icon={<PlusOutlined />}
        className={isMobile ? 'full-width' : ''}
        onClick={() => {
          if (typeof openModal === 'function') {
            openModal();
          }
        }}
        data-testid="add-client-field"
      >
        {label}
      </Button>
    </div>
  );
};
